import Vue from 'vue'
import VueRouter from 'vue-router'
import App from '@/views/informationDetail/index.vue'
// import router from '@/router/builderPage/index.js'
import '@/utils/remH5.js'
import '@/assets/css/common.less'
import '@/assets/less/ico.less'
import { toggleDebug } from '@/utils'
import JSBridge from '@fs/jsbridge/dist/lib/jsBridge.js'
import { thsI18NJsBridge } from '@fs/jsbridge'
import { i18n } from '@/i18n/information/index.js'
import './init.js'
import VantComponents from '@/config/vant.components.js'
import { setTheme } from '@/utils/theme'
import store from '@/store/baseStore'
import '@/utils/registerSentry.js'

VantComponents(Vue)

// error handler
import { initErrorLoggerHandler } from '@/utils/logService'
initErrorLoggerHandler()

Vue.use(VueRouter)
const router = new VueRouter()
router.beforeEach(to => {
    console.log(`base ==> file: informationDetail.js ==> line 14 ==> router.beforeEach ==> to`, to)
    const title = i18n.t('informationTitle')
    document.title = title
    if (thsI18NJsBridge.isTHSI18NApp()) {
        thsI18NJsBridge.changeWebViewTitle(title)
    }
    if (to.path === '/') {
        setTheme()
    }
})

Vue.prototype.jsBridge = JSBridge
// import store from '@/store/builderPage'
Vue.config.ignoredElements = ['wx-open-launch-app']

const { VUE_APP_ENV = 'sit' } = process.env
if (VUE_APP_ENV !== 'prod') {
    toggleDebug(true)
}

new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
}).$mount('#app')
